import axios from 'axios'
import * as utils from './apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/tenken_data_roka'), {
      params: params || {}
    })
  },
  search(params) {
    return axios.get(utils.getApiUrl('/tenken_data_roka/search'), {
      params: params || {}
    })
  },
  create(params) {
    return axios.post(utils.getApiUrl('/tenken_data_roka'), params)
  },
  show(id) {
    return axios.get(utils.getApiUrl(`/tenken_data_roka/${id}`))
  },
  update(id, params) {
    return axios.put(utils.getApiUrl(`/tenken_data_roka/${id}`), params)
  },
  delete(id) {
    return axios.delete(utils.getApiUrl(`/tenken_data_roka/${id}`))
  },
  bulkUpdatePhotos(id, params) {
    return axios.post(utils.getApiUrl(`/tenken_data_roka/${id}/bulk_update_photos`), params)
  },
  downloadHoshuReportCSV(params) {
    return axios.get('/tenken_data_roka/download_hoshu_report_csv.csv', {
      params: params,
      responseType: 'blob',
    })
  },
  downloadSearchResultCSV(params) {
    return axios.get('/tenken_data_roka/download_search_result_csv.csv', {
      params: params,
      responseType: 'blob',
    })
  },
  getDailyReport(params) {
    return axios.post(utils.getApiUrl('/tenken_data_roka/get_daily_report'), params)
  },
  getMonthlyReport(params) {
    return axios.post(utils.getApiUrl('/tenken_data_roka/get_monthly_report'), params)
  },
}
